export const IdentityProvider = {
    RAVEN: "RAVEN",
    GOOGLE: "GOOGLE",
    OIDC: "OIDC",
    APPLE: "APPLE",
    FACEBOOK: "FACEBOOK"
} as const;
export type IdentityProvider = (typeof IdentityProvider)[keyof typeof IdentityProvider];
export const UserRole = {
    ORG_OWNER: "ORG_OWNER",
    ORG_MANAGER: "ORG_MANAGER",
    ORG_OFFICER: "ORG_OFFICER",
    ORG_KYB_OFFICER: "ORG_KYB_OFFICER",
    ORG_KYC_OFFICER: "ORG_KYC_OFFICER",
    ORG_VIEWER: "ORG_VIEWER"
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];
export const UserType = {
    USER: "USER",
    ADMIN: "ADMIN"
} as const;
export type UserType = (typeof UserType)[keyof typeof UserType];
export const UserSecurityAuditLogType = {
    ACCOUNT_CREATED: "ACCOUNT_CREATED",
    ACCOUNT_PROFILE_UPDATE: "ACCOUNT_PROFILE_UPDATE",
    ACCOUNT_SSO_LINK: "ACCOUNT_SSO_LINK",
    ACCOUNT_SUSPENDED: "ACCOUNT_SUSPENDED",
    ACCOUNT_REACTIVATED: "ACCOUNT_REACTIVATED",
    AUTH_2FA_DISABLE: "AUTH_2FA_DISABLE",
    AUTH_2FA_ENABLE: "AUTH_2FA_ENABLE",
    AUTH_PASSWORD_RESET: "AUTH_PASSWORD_RESET",
    AUTH_PASSWORD_UPDATE: "AUTH_PASSWORD_UPDATE",
    AUTH_SESSION_REVOKED: "AUTH_SESSION_REVOKED",
    AUTH_SIGN_OUT: "AUTH_SIGN_OUT",
    AUTH_SIGN_IN_SUCCESS: "AUTH_SIGN_IN_SUCCESS",
    AUTH_SIGN_IN_FAILED: "AUTH_SIGN_IN_FAILED",
    AUTH_2FA_FAILED: "AUTH_2FA_FAILED",
    AUTH_PASSKEY_FAILED: "AUTH_PASSKEY_FAILED",
    PASSKEY_CREATED: "PASSKEY_CREATED",
    PASSKEY_DELETED: "PASSKEY_DELETED",
    PASSKEY_UPDATED: "PASSKEY_UPDATED",
    DATA_EXPORTED: "DATA_EXPORTED",
    DATA_DELETED: "DATA_DELETED",
    PERMISSION_CHANGED: "PERMISSION_CHANGED"
} as const;
export type UserSecurityAuditLogType = (typeof UserSecurityAuditLogType)[keyof typeof UserSecurityAuditLogType];
export const VerificationTokenIdentifier = {
    CONFIRMATION_EMAIL: "CONFIRMATION_EMAIL",
    ORGANIZATION_INVITATION: "ORGANIZATION_INVITATION",
    OTP_CODE: "OTP_CODE",
    PASSKEY_CHALLENGE: "PASSKEY_CHALLENGE"
} as const;
export type VerificationTokenIdentifier = (typeof VerificationTokenIdentifier)[keyof typeof VerificationTokenIdentifier];
export const OrganizationStatus = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    SUSPENDED: "SUSPENDED",
    DELETED: "DELETED",
    UNVERIFIED: "UNVERIFIED"
} as const;
export type OrganizationStatus = (typeof OrganizationStatus)[keyof typeof OrganizationStatus];
export const BackgroundJobStatus = {
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED"
} as const;
export type BackgroundJobStatus = (typeof BackgroundJobStatus)[keyof typeof BackgroundJobStatus];
export const BackgroundJobTaskStatus = {
    PENDING: "PENDING",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED"
} as const;
export type BackgroundJobTaskStatus = (typeof BackgroundJobTaskStatus)[keyof typeof BackgroundJobTaskStatus];
export const WebhookTriggerEvents = {
    REPORT_GENERATED: "REPORT_GENERATED"
} as const;
export type WebhookTriggerEvents = (typeof WebhookTriggerEvents)[keyof typeof WebhookTriggerEvents];
export const WebhookCallStatus = {
    SUCCESS: "SUCCESS",
    FAILED: "FAILED"
} as const;
export type WebhookCallStatus = (typeof WebhookCallStatus)[keyof typeof WebhookCallStatus];
export const ApiTokenAlgorithm = {
    SHA512: "SHA512"
} as const;
export type ApiTokenAlgorithm = (typeof ApiTokenAlgorithm)[keyof typeof ApiTokenAlgorithm];
